/* eslint-disable import/no-internal-modules */
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@insided/deprecated-preact-components/modal'

interface ChangeAuthorModalProps {
  numberOfSelectedItems: number
  isOpen: boolean
  onChangeAuthor: () => void
  onClose: () => void
  authorName: string
  type: string
}

const ChangeAuthorModal = ({
  numberOfSelectedItems,
  isOpen,
  onChangeAuthor,
  onClose,
  authorName,
  type
}: ChangeAuthorModalProps) => {
  const bodyText =
    numberOfSelectedItems > 1 ? (
      <p>
        You will change the author of the {numberOfSelectedItems} selected {type}s to{' '}
        <b>{authorName}</b>.
      </p>
    ) : (
      <p>
        You will change the author of the selected {type} to <b>{authorName}</b>.
      </p>
    )
  return (
    <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title='Change author?' onClose={() => onClose()} />
      <ModalBody>
        <div className='change-author-modal'>{bodyText}</div>
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          // eslint-disable-next-line @gorazdo/preact/prefer-classname
          class='qa-change-author'
          title='Change author'
          newStyle
          onClick={onChangeAuthor}
          size='medium'
          variant='brand'
        />
        <ButtonControl title='Cancel' newStyle onClick={onClose} size='medium' />
      </ModalFooter>
    </Modal>
  )
}

export default ChangeAuthorModal
